import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-2"},[_c(VTextField,{class:_vm.props.theme.input,attrs:{"name":_vm.props.getColumnName(_vm.props.column),"value":_vm.props.query[_vm.props.column],"type":"text","placeholder":_vm.props.display('filterBy', {column: _vm.props.getHeading(_vm.props.column)}),"autocomplete":"off","dense":""},on:{"keyup":e => _vm.props.search(_vm.props.debounce)(e)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }